<template>
  <div :class="$route.fullPath=='/home'?'header-box':'header-box-bg'">

    <div>

      <header class="w">
        <div class="w-box">

          <div class="nav-logo">
            <router-link to="/login" title="医小智-牙嗖嗖"></router-link>
          </div>

          <!-- 菜单显示 -->
          <div class="menu-box">
            <div :class="user.isLogin == true?'nav-list-login':'nav-list'">
              <li v-for="(item,i) in navList" :key="i">
                <a :class="{active:common.navSelect.navIndex === i}" @click="changeNav(i,item)">{{item.navLabel}}</a>
              </li>
            </div>
          </div>
          <div class="right-box">
            <div class="nav-logo2" v-if="!user.isLogin">
              <span class="login-txt" @click="toLogin">登录</span>
              <router-link to="/login" title="医小智-牙嗖嗖"></router-link>
            </div>
            <div class="nav-aside" ref="aside" :class="{fixed:st}" :style="user.isLogin == true?'opacity:1;':'opacity:0;'">
              <div class="user pr">
                <router-link to="/user">个人中心</router-link>
                <!-- 用户信息显示 start -->
                <div class="nav-user-wrapper pa" v-if="user.isLogin">
                  <div class="nav-user-list">
                    <ul style="display: flex;flex-direction: column;" >
                      <!--头像-->
                      <li class="nav-user-avatar">
                        <div>
                          <span class="avatar"
                            :style="user ? (user.avatar?'background-image:url(' + user.avatar + ')':'background-image:url(/static/images/default.png)') : 'background-image:url(/static/images/smile.png)'"></span>
                        </div>
                        <p class="name">{{user ? user.loginName : ''}}</p>
                      </li>
              <!--        <li>
                        <router-link to="/user/information">账户中心</router-link>
                      </li> -->
                 <!--     <li v-if="this.user.userType==20">
                        <router-link to="/user/orderList">我的设计单</router-link>
                      </li>
                      <li>
                        <router-link to="/user/orderList">商城订单</router-link>
                      </li>
                      <li>
                        <router-link to="/user/support">下载中心</router-link>
                      </li> -->
                      <li>
                        <a href="javascript:;" @click="clickLogout">退出账号</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <!-- 用户信息显示 end -->
              </div>
              <!-- <div class="user pr">
                <router-link to="/user">个人中心</router-link>
                <div class="nav-user-wrapper pa" v-if="login">
                  <div class="nav-user-list">
                    <ul>
                      <li class="nav-user-avatar">
                        <div>
                          <span class="avatar" :style="{backgroundImage:'url('+userInfo.info.file+')'}">
                          </span>
                        </div>
                        <p class="name">{{userInfo.info.username}}</p>
                      </li>
                      <li>
                        <router-link to="/user/orderList">我的订单</router-link>
                      </li>
                      <li>
                        <router-link to="/user/information">账号资料</router-link>
                      </li>
                      <li>
                        <router-link to="/user/addressList">收货地址</router-link>
                      </li>
                      <li>
                        <router-link to="/user/support">售后服务</router-link>
                      </li>
                      <li>
                        <router-link to="/user/coupon">我的优惠</router-link>
                      </li>
                      <li>
                        <a href="javascript:;" @click="_loginOut">退出</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div> -->
              <div class="shop pr" @mouseover="cartShowState(true)" @mouseout="cartShowState(false)" ref="positionMsg">
                <router-link to="/cart"></router-link>
                <span class="cart-num">
                  <i class="num" :class="{no:totalNum <= 0,move_in_cart:cart.receiveInCart}">{{totalNum}}</i></span>
                <!--购物车显示块-->
                <div class="nav-user-wrapper pa active" v-show="cart.showCart">
                  <div class="nav-user-list">
                    <div class="full" v-show="totalNum">
                      <!--购物列表-->
                      <div class="nav-cart-items">
                        <ul>
                          <li class="clearfix" v-for="(item,i) in cart.cartList" :key="i">
                            <div class="cart-item">
                              <div class="cart-item-inner">
                                <a @click="openProduct(item.productId)">
                                  <div class="item-thumb">
                                    <img :src="item.productImg">
                                  </div>
                                  <div class="item-desc">
                                    <div class="cart-cell">
                                      <h4>
                                        <a href="" v-text="item.productName"></a>
                                      </h4>
                                      <!-- <p class="attrs"><span>白色</span></p> -->
                                     <!-- <h6><span class="price-icon">¥</span><span
                                          class="price-num">{{item.salePrice}}</span>
                                           -->
                                           <span class="item-num">x
                                           {{item.productNum}}</span>
                                      <!-- </h6> -->
                                    </div>
                                  </div>
                                </a>
                                <div class="del-btn del" @click="delGoods(item.productId)">删除</div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                      <!--总件数-->
                      <div class="nav-cart-total">
                        <p>共 <strong>{{totalNum}}</strong> 件商品</p>
                        <!-- <h5>合计：<span class="price-icon">¥</span><span class="price-num">{{totalPrice}}</span></h5>
                        <h6>
                          <y-button classStyle="main-btn"
                            style="height: 40px;width: 100%;margin: 0;color: #fff;font-size: 14px;line-height: 38px"
                            text="去购物车" @btnClick="toCart"></y-button>
                        </h6> -->
                      </div>
                    </div>
                    <div v-show="!totalNum" style="height: 313px;text-align: center" class="cart-con">
                      <p>您的购物车竟然是空的!</p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="msg pr" v-if="user.isLogin">
                <router-link to="/msg">消息中心</router-link>
                <span class="msg-num">
                  <i class="num"></i>
                </span>
                <div class="nav-user-wrapper pa active" v-if="user.isLogin">

                  <div class="nav-user-list">

                    <div class="full">
                      <div class="nav-msg-items">

                        <ul>

                          <li class="clearfix">
                            <a>
                              <div class="msg-item">
                                <div class="msg-item-desc">系统消息</div>
                                <span class="msg-item-num">
                                  <i class="num">12</i>
                                </span>
                              </div>
                            </a>
                          </li>

                          <li class="clearfix">
                            <a>
                              <div class="msg-item">
                                <div class="msg-item-desc">通知消息</div>
                                <span class="msg-item-num">
                                  <i class="num">8</i>
                                </span>
                              </div>
                            </a>
                          </li>

                          <li class="clearfix">
                            <a>
                              <div class="msg-item">
                                <div class="msg-item-desc">私信消息</div>
                                <span class="msg-item-num">
                                  <i class="num">1</i>
                                </span>
                              </div>
                            </a>
                          </li>

                        </ul>
                      </div>
                      <div class="nav-msg-total">
                        <a>
                          查看全部
                        </a>
                      </div>

                    </div>

                  </div>

                </div>
              </div> -->

              <!--              <div class="cart pr">
                <router-link to="/msg">消息中心</router-link>
                <span class="msg-num">
                  <i class="num"></i>
                </span>
                <div class="nav-user-wrapper pa active" v-if="user.isLogin">
                  <div class="nav-user-list">
                    <div class="full">
                      <div class="nav-msg-items">
                        <ul>
                          <li class="clearfix">
                            <a>
                              <div class="msg-item">
                                <div class="msg-item-desc">系统消息</div>
                                <span class="msg-item-num">
                                  <i class="num">12</i>
                                </span>
                              </div>
                            </a>
                          </li>
                          <li class="clearfix">
                            <a>
                              <div class="msg-item">
                                <div class="msg-item-desc">通知消息</div>
                                <span class="msg-item-num">
                                  <i class="num">8</i>
                                </span>
                              </div>
                            </a>
                          </li>
                          <li class="clearfix">
                            <a>
                              <div class="msg-item">
                                <div class="msg-item-desc">私信消息</div>
                                <span class="msg-item-num">
                                  <i class="num">1</i>
                                </span>
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div class="nav-msg-total">
                        <a>
                          查看全部
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
          <div :class="user.isLogin == true?'bot-login':'bot-hr'"></div>
      </header>
      <slot name="nav" v-if="$route.fullPath!='/home'">
        <div class="nav-sub" :class="{fixed:st}" v-if="$route.fullPath!='/downLoad'">
          <div class="nav-sub-wrapper" :class="{fixed:st}">
            <div class="w">
              <ul class="nav-sub-list">
                <li v-for="(item,i) in navSubList" :key="i">
                  <a @click="changeSubNav(i, item)"
                    :class="{active:common.navSelect.navSubIndex===i}">{{item.navLabel}}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </slot>

    </div>
	<el-dialog :visible.sync="dialogVisible" width="600px" center>
	  <div slot="title" class="header-title">
	    <div style="padding:15px 20px;">认证申请</div>
	  </div>
	  <!-- <div style=""> -->
	  <div style="display: flex; align-items: center; justify-content:space-around;height: 300px;">
	    <div class="item itme1">
	      <a @click="factory">
	        <div class="t fiex f-18">
	          <div class="t2 center"><img src="/static/images/zc11.png">
	            <!-- <p class="mag-t-20">认证诊所/工厂进行下单</p> -->
	          </div>
	        </div>
	        <div class="p">诊所/工厂认证</div>
	      </a>
	    </div>
	    <div class="item itme2">
	      <a @click="designer">
	        <div class="t fiex f-18">
	          <div class="t2 center"><img src="/static/images/zc22.png">
	            <!-- <p class="mag-t-20">认证成为设计师进行接单</p> -->
	          </div>
	        </div>
	        <div class="p">设计师认证</div>
	      </a>
	    </div>
	  </div>
	  <!-- </div> -->
	</el-dialog>
  </div>
</template>
<script>
  import {
    mapState
  } from 'vuex'
  import {
    setStore,
    getStore,
    removeStore
  } from '/utils/storage'
  import YButton from '../components/YButton.vue'
  import navList from "/assets/config/navList.js";
  import navDemList from "/assets/config/navDemList.js";
  import navDesList from "/assets/config/navDesList.js";
  export default {
    data() {
      return {
        // currentNav: -1,
        // currentSubNav: -1,
        st: false,
        navList: [],
        navSubList: [],
        positionL: 0,
        positionT: 0,
        msgNum: 0,
        token: '',
        cartShow: false,
        dialogVisible: false,
        template: '99',
        selWidth:'110px',
      }
    },
    components: {
      YButton
    },
    computed: {
      // ...mapState([
      //   'cartList', 'login', 'receiveInCart', 'showCart', 'userInfo'
      // ]),
      ...mapState(['common', 'user', 'cart']),
      // 计算价格
      totalPrice() {
        var totalPrice = 0
        this.cart.cartList && this.cart.cartList.forEach(item => {
          totalPrice += (item.productNum * item.salePrice)
        })
        return totalPrice
      },
      // 计算数量
      totalNum() {
        var totalNum = 0
        this.cart.cartList && this.cart.cartList.forEach(item => {
          totalNum += (item.productNum)
        })
        return totalNum
      }
    },
    methods: {
      toLogin(){
        this.$router.push('/login');
      },
      loadNav() {
        switch (this.user.userType) {
          case "10":
            this.navList = navDemList;
            break;
          case "20":
            this.navList = navDesList;
            break;
          default:
            this.navList = navList;
            break;
        }
        if (this.$route.meta.SubNav) {
          if (this.common.navSelect.navIndex === -1) {
            this.common.navSelect.navIndex = 0;
            this.common.navSelect.navSubIndex = 0;
          }
          this.navSubList = this.navList[this.common.navSelect.navIndex].navSubList;
        }
      },
      // 记录主导航栏
      changeNav(index, item) {
        localStorage.removeItem('matchUpload');
        if(index!=0){
          sessionStorage.clear();
        }
        this.$store.commit('common/recordNav', {
          navIndex: index,
          navSubIndex: 0
        })
        this.navSubList = this.navList[index].navSubList;
        
        if(item.navLabel == 'Online设计平台'&&this.user.authFlag == '00'){
		    if (this.user.isLogin) {

		      if (this.user.userType === '10') {
		        window.open('//' + window.location.host + '/#/order/create?catalogId=' + index)
		      }
		      if (this.user.userType === '20') {
		        window.open('//' + window.location.host + '/#/order/mall')
		      }

		      if (this.user.userType === '99') {
		        this.$yxz.msg('账号未认证，请提交认证资料', 'error')

		        if (this.user.authFlag == '00') {
		          this.dialogVisible = true
		        }
		        if (this.user.authFlag == '02') {
		          this.dialogVisible = true
		        }
		        if (this.user.authFlag == '99') {
		          this.dialogVisible = true
		        }
		      }

		    } else {

		      this.$yxz.msg('未登录或登录状态已过期,请重新登录', 'error')
		      var that = this;
		      setTimeout(function() {
		        that.$yxz.to('/login')
		      }, 1500);
        }
        }else if(item.navLabel == 'Online设计平台'&&this.user.authFlag == '02'){
          this.$message({
            message: '您的认证信息正在审核中，请稍后重试...',
            type: 'success'
          });
        }else if(item.navLabel == 'Online设计平台'&&this.user.authFlag == '99'){
          this.$yxz.msg('账号未认证或认证被驳回，请提交认证资料', 'error')
          this.dialogVisible = true;
        }else{
        this.linkTo(item);
        }
      },
      // 记录子导航栏
      changeSubNav(index, item) {
        this.common.navSelect.navSubIndex = index;
        this.$store.commit('common/recordNav', {
          navIndex: this.common.navSelect.navIndex,
          navSubIndex: index
        })
        this.linkTo(item);
        sessionStorage.clear();
      },
      linkTo(item) {
        if (item.linkType === 1) {
          this.$yxz.to('/' + item.linkUrl)
        } else if (item.linkType === 2) { // 站内跳转
          window.open('//' + window.location.host + '/#/' + item.linkUrl)
        } else if (item.linkType === 9) {
          this.$router.push({
            path: "/" + item.linkUrl,
            query: item.query
          })
        } else { // 站外跳转
          window.open(item.linkUrl)
        }

      },
      // 退出登陆
      clickLogout() {
        this.$api.post({
          url: '/logout',
          data: {
            token: this.token
          }
        }).then(res => {
          this.$store.dispatch('user/logout');
          this.$store.commit('common/resetNav');
          this.loadNav();
          this.$yxz.to("/home");
          this.$yxz.msg("退出成功");
        })
        sessionStorage.clear()
      },
      // 控制顶部
      navFixed() {
        if (this.$route.meta.SubNav) {
          var st = document.documentElement.scrollTop || document.body.scrollTop
          st >= 60 ? this.st = true : this.st = false
          // 计算小圆当前位置
          let num = document.querySelector('.num')
          this.positionL = num.getBoundingClientRect().left
          this.positionT = num.getBoundingClientRect().top
          this.$store.commit('cart/addanimation', {
            cartPositionL: this.positionL,
            cartPositionT: this.positionT
          })
          // this.ADD_ANIMATION({cartPositionL: this.positionL, cartPositionT: this.positionT})
        } else {
          return
        }
      },
      // 购物车显示
      cartShowState(state) {
        this.$store.commit('cart/showcart', {
          showCart: state
        })
      },
      // 登陆时获取一次购物车商品
      _getCartList() {
        // getCartList({userId: getStore('userId')}).then(res => {
        //   if (res.success === true) {
        //     setStore('buyCart', res.result)
        //   }
        //   // 重新初始化一次本地数据
        // }).then(this.$store.commit("cart/initcart"))
      },
      toCart() {
        this.$router.push({
          path: '/cart'
        })
      },
      // 删除商品
      delGoods(productId) {
        if (this.user.login) { // 登陆了
          cartDel({
            userId: getStore('userId'),
            productId
          }).then(res => {
            this.$store.commit('cart/editcart', {
              productId
            })
          })
        } else {
          this.$store.commit('cart/editcart', {
            productId
          })
        }
      },
      openProduct(productId) {
        window.open('//' + window.location.host + '/#/goodsDetails?productId=' + productId)
      },
	  designer() {
	    this.$yxz.to('/designerAuth')
	    this.dialogVisible = false
	  },
	  factory() {
	    this.$yxz.to('/factoryAuth')
	    this.dialogVisible = false
	  },
    },
    mounted() {
      this.token = getStore('token')
      this.navFixed()
      if (this.login) {
        this._getCartList()
      } else {
        this.$store.commit("cart/initcart")
      }
      window.addEventListener('scroll', this.navFixed)
      window.addEventListener('resize', this.navFixed)
      this.loadNav();
      if(this.$route.fullPath.includes('/order/orthodonticsCreateOrder')||
         this.$route.fullPath.includes('/order/active/bracket')){
        this.navSubList = this.navList[1].navSubList;
      }
    }

  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
  @import "../assets/style/theme";
  @import "../assets/style/mixin";

  .move_in_cart {
    animation: mymove .5s ease-in-out;
  }

  @keyframes mymove {
    0% {
      transform: scale(1)
    }

    25% {
      transform: scale(.8)
    }

    50% {
      transform: scale(1.2)
    }

    75% {
      transform: scale(.9)
    }

    100% {
      transform: scale(1)
    }
  }

  @-moz-keyframes mymove {
    0% {
      transform: scale(1)
    }

    25% {
      transform: scale(.8)
    }

    50% {
      transform: scale(1.2)
    }

    75% {
      transform: scale(.9)
    }

    100% {
      transform: scale(1)
    }
  }

  @-webkit-keyframes mymove {
    0% {
      transform: scale(1)
    }

    25% {
      transform: scale(.8)
    }

    50% {
      transform: scale(1.2)
    }

    75% {
      transform: scale(.9)
    }

    100% {
      transform: scale(1)
    }
  }

  @-o-keyframes mymove {
    0% {
      transform: scale(1)
    }

    25% {
      transform: scale(.8)
    }

    50% {
      transform: scale(1.2)
    }

    75% {
      transform: scale(.9)
    }

    100% {
      transform: scale(1)
    }
  }

  .header-box {
    // background: $head-bgc;
    // background-image: -webkit-gradient(linear, left top, right top, from(#222325), color-stop(#3b3c3f), to(#222325));
    // background-image: linear-gradient(90deg, #222325, #3b3c3f, #222325);
    // background-color: white;
    background-image: url(/static/images/square.png);
    width: 100%;
  }

  .header-box-bg{
    background-color: white;
    background-size: 120%;
    width: 100%;
  }

  header {
    height:70px;
    z-index: 30;
    position: relative;
  }

  .w-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;

    .nav-logo {
      position: relative;
      height: 80px;
      display: flex;
      align-items: center;

      >a {
        background: url(/static/images/yxz.png) no-repeat 100%;
        background-size: cover;
        display: block;
        @include wh(130px, 50px);
        text-indent: -9999px;
        background-position: 0 0;
      }

    }

    .nav-logo2 {
      position: relative;
      // width:100%;
      // height: 36px;
      display: flex;
      align-items: center;
      background: url(/static/images/login_test1.png) no-repeat;
      background-size: 100%;
      margin: 15px 0 0 0px;
      >a {
        background-size: cover;
        display: block;
        @include wh(110px, 55px);
        text-indent: -9999px;
        background-position: 0 0;
      }
      .login-txt{
        position: absolute;
        top: 9px;
        left: 26px;
        display: block;
        cursor: pointer;
        width: 40px;
        height: 20px;
        font-size: 15px;
        color: #2D5FD6;
      }
    }

    .menu-box {
      flex: 1;
      // margin: 0 50px;
    }

    .nav-list,.nav-list-login {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      a {
        color: black;
        display: block;
        font-size: 14px;
        padding: 10px 0;
        text-align: center;
        border-radius: 5px;
        // &:hover {
        //   color: #fff;
        //   background: #222325;
        // }

        // &.active {
        //   font-weight: bold;
        //   color: #fff;
        //   background: #222325;
        // }

        &:hover {
          // color: #fff;
          color: rgba(25,94,251,0.7);
          // background: rgba(25,94,251,0.7);
        }

        &.active {
          font-weight: bold;
          color: rgba(25,94,251,0.7);
          // color: rgba(25,94,251,0.7);
          // background: rgba(25,94,251,0.7);
        }
      }
    }

    .nav-list{
      margin-left: -15px;
      margin-top: -15px;
      a{
        width: 110px;
      }
    }
    .nav-list-login{
      a{
        width: 110px;
      }
    }

    .nav-aside {
      position: relative;

      &.fixed {
        // width: 262px;
        position: fixed;
        // left: 50%;
        // margin-left: 458px;
        right: calc((100vw - 1220px)/2);
        margin-top: 0;
        z-index: 32;
        top: -46px;
        -webkit-transform: translate3d(0, 59px, 0);
        transform: translate3d(0, 59px, 0);
        -webkit-transition: -webkit-transform .3s cubic-bezier(.165, .84, .44, 1);
        transition: transform .3s cubic-bezier(.165, .84, .44, 1);
      }

    }

    .right-box {
      display: flex;
    }

    .nav-aside {
      display: flex;
      align-items: center;
    }

    // 用户中心
    .user {
      &:hover {

        a:before {
          // background: url(/static/images/rbox/people_fill.png) no-repeat center bottom / 100% auto;
          background-position: -5px 0;
        }

        .nav-user-wrapper {
          top: 18px;
          visibility: visible;
          opacity: 1;
          -webkit-transition: opacity .15s ease-out;
          transition: opacity .15s ease-out;
        }
      }

      >a {
        position: relative;
        @include wh(50px, 20px);
        display: block;
        text-indent: -9999px;

        &:before {
          content: " ";
          position: absolute;
          left: 15px;
          top: 0;
          @include wh(20px);
          // background: url(/static/images/rbox/people.png) no-repeat center bottom / 100% auto;
          background: url(/static/images/account-icon@2x.32d87deb02b3d1c3cc5bcff0c26314ac.png) -155px 0;
          background-size: 240px 107px;
          transition: none;
        }

      }

      li+li {
        text-align: center;
        position: relative;
        border-top: 1px solid #f5f5f5;
        line-height: 44px;
        height: 44px;
        color: #616161;
        font-size: 12px;

        &:hover {
          background: #fafafa;
        }

        a {
          display: block;
          color: #616161;
        }
      }

      .nav-user-wrapper {
        width: 168px;
        transform: translate(-50%);
        left: 50%;
      }

      .nav-user-list {
        width: 168px;

        &:before {
          left: 50%;
        }

        li:last-child {
          border-radius: 0 0 8px 8px;
        }
      }

      .nav-user-avatar {
        >div {
          position: relative;
          margin: 0 auto 8px;
          @include wh(46px);
          text-align: center;

          &:before {
            content: "";
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            border-radius: 50%;
            box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .06);
          }

          .avatar {
            border-radius: 50%;
            display: block;
            @include wh(100%);
            background-repeat: no-repeat;
            background-size: contain;
          }

        }

        .name {
          margin-bottom: 16px;
          font-size: 12px;
          line-height: 1.5;
          text-align: center;
          color: #757575;
        }
      }

    }

    // 消息中心
    .msg {

      &:hover {
        a:before {
          background: url(/static/images/rbox/notice_fill.png) no-repeat center bottom / 100% auto;
        }

        .nav-user-wrapper.active {
          top: 18px;
          visibility: visible;
          opacity: 1;
          -webkit-transition: opacity .15s ease-out;
          transition: opacity .15s ease-out;
        }

      }

      >a {
        position: relative;
        @include wh(50px, 20px);
        display: block;
        text-indent: -9999px;

        &:before {
          content: " ";
          position: absolute;
          left: 15px;
          top: 0;
          @include wh(20px);
          background: url(/static/images/rbox/notice.png) no-repeat center bottom / 100% auto;
          transition: none;
        }

      }

      li {
        text-align: center;
        position: relative;
        border-top: 1px solid #f5f5f5;
        line-height: 44px;
        height: 44px;
        color: #616161;
        font-size: 12px;

        &:hover {
          background: #fafafa;
        }

        a {
          display: block;
          color: #616161;
        }

      }

      .msg-num {
        position: absolute;
        display: block;
        margin-left: 25px;
        margin-top: -25px;
        min-width: 30px;
        text-indent: 0;
        line-height: 20px;

        >i {
          background: #eb746b;
          background-image: -webkit-linear-gradient(#eb746b, #e25147);
          background-image: linear-gradient(#eb746b, #e25147);
          box-shadow: inset 0 0 1px hsla(0, 0%, 100%, .15), 0 1px 2px hsla(0, 0%, 100%, .15);
          text-align: center;
          font-style: normal;
          display: inline-block;
          @include wh(12px);
          border-radius: 12px;
          color: #fff;
          font-size: 12px;

          &.no {
            background: #969696;
            background-image: -webkit-linear-gradient(#A4A4A4, #909090);
            background-image: linear-gradient(#A4A4A4, #909090);
            box-shadow: inset 0 0 1px #838383, 0 1px 2px #838383;
          }
        }

      }

      .nav-user-wrapper {
        right: 0;
        width: 168px;

        .nav-user-list {
          &:before {
            right: 13px;
          }
        }
      }

      .nav-user-list {
        padding: 0;
        width: 100%;

        .full {
          border-radius: 8px;
          overflow: hidden;
        }

        .nav-msg-items {
          max-height: 363px;
          overflow-x: hidden;
          overflow-y: auto;
        }

        .msg-item {
          height: 44px;
          width: 100%;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;

          &:hover {
            background: #fcfcfc;
          }

          .msg-item-desc {
            color: #616161;
            font-size: 12px;
          }

          .msg-item-num {
            position: absolute;
            right: 10px;
            display: block;
            min-width: 30px;
            text-indent: 0;
            line-height: 20px;

            >i {
              background: #eb746b;
              background-image: -webkit-linear-gradient(#eb746b, #e25147);
              background-image: linear-gradient(#eb746b, #e25147);
              box-shadow: inset 0 0 1px hsla(0, 0%, 100%, .15), 0 1px 2px hsla(0, 0%, 100%, .15);
              text-align: center;
              font-style: normal;
              display: inline-block;
              @include wh(20px);
              border-radius: 20px;
              color: #fff;
              font-size: 12px;

              &.no {
                background: #969696;
                background-image: -webkit-linear-gradient(#A4A4A4, #909090);
                background-image: linear-gradient(#A4A4A4, #909090);
                box-shadow: inset 0 0 1px #838383, 0 1px 2px #838383;
              }
            }

          }


        }

        li:first-child .msg-item:first-child {
          border-top: none;
          border-radius: 8px 8px 0 0;
          overflow: hidden;
        }

      }

      .nav-msg-total {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        height: 44px;
        background: #fafafa;
        border-top: 1px solid #f0f0f0;
        border-radius: 0 0 8px 8px;
        box-shadow: inset 0 -1px 0 hsla(0, 0%, 100%, .5), 0 -3px 8px rgba(0, 0, 0, .04);
        background: -webkit-linear-gradient(#fafafa, #f5f5f5);
        background: linear-gradient(#fafafa, #f5f5f5);

        &:hover {
          background: #fcfcfc;
        }

        a {
          display: block;
          color: #616161;
        }
      }

    }

    .shop {
      position: relative;
      float: left;
      margin-left: 21px;
      width: 61px;
      z-index: 99;

      &:hover {
        a:before {
          content: " ";
          background-position: 0 -22px;
        }
      }

      .nav-user-wrapper.active {
        top: 18px;
        visibility: visible;
        opacity: 1;
        -webkit-transition: opacity .15s ease-out;
        transition: opacity .15s ease-out;
      }

      >a {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        display: block;
        right: 0;
        z-index: 1;

        &:before {
          display: block;
          @include wh(30px, 100%);
          content: " ";
          background: url(/static/images/account-icon@2x.32d87deb02b3d1c3cc5bcff0c26314ac.png) 0 -22px;
          background-size: 240px 107px;
          background-position: -150px -22px;
        }
      }

      .cart-num {
        position: relative;
        display: block;
        margin-left: 31px;
        margin-top: -1px;
        min-width: 30px;
        text-indent: 0;
        line-height: 20px;

        >i {
          background: #eb746b;
          background-image: -webkit-linear-gradient(#eb746b, #e25147);
          background-image: linear-gradient(#eb746b, #e25147);
          box-shadow: inset 0 0 1px hsla(0, 0%, 100%, .15), 0 1px 2px hsla(0, 0%, 100%, .15);
          text-align: center;
          font-style: normal;
          display: inline-block;
          @include wh(20px);
          line-height: 20px;
          border-radius: 10px;
          color: #fff;
          font-size: 12px;

          &.no {
            background: #969696;
            background-image: -webkit-linear-gradient(#A4A4A4, #909090);
            background-image: linear-gradient(#A4A4A4, #909090);
            box-shadow: inset 0 0 1px #838383, 0 1px 2px #838383;
          }
        }

      }

      .nav-user-wrapper {
        right: 0;
        width: 360px;

        .nav-user-list {
          &:before {
            right: 34px;
          }
        }
      }

      .nav-user-list {
        padding: 0;
        width: 100%;

        .full {
          border-radius: 8px;
          overflow: hidden;
        }

        .nav-cart-items {
          max-height: 363px;
          overflow-x: hidden;
          overflow-y: auto;
        }

        .cart-item {
          height: 120px;
          width: 100%;
          overflow: hidden;
          border-top: 1px solid #f0f0f0;

          &:hover {
            background: #fcfcfc;

            .del {
              display: block;
            }
          }

        }

        li:first-child .cart-item:first-child {
          border-top: none;
          border-radius: 8px 8px 0 0;
          overflow: hidden;
        }

        .cart-item-inner {
          padding: 20px;
          position: relative;
        }

        .item-thumb {
          position: relative;
          float: left;
          width: 80px;
          height: 80px;
          border-radius: 3px;

          &:before {
            content: "";
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            z-index: 2;
            border: 1px solid #f0f0f0;
            border: 0 solid transparent;
            box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .06);
            border-radius: 3px;
          }

          img {
            display: block;
            @include wh(80px, 80px);
            border-radius: 3px;
            overflow: hidden;
          }
        }

        .item-desc {
          margin-left: 98px;
          display: table;
          @include wh(205px, 80px);

          h4 {
            color: #000;
            width: 185px;
            overflow: hidden;
            word-break: keep-all;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 14px;
            line-height: 16px;
            margin-bottom: 10px;
          }

          .attrs span {
            position: relative;
            display: inline-block;
            margin-right: 20px;
            font-size: 14px;
            line-height: 14px;
            color: #999;
          }

          .attrs span:last-child {
            margin-right: 0;
          }

          h6 {
            color: #cacaca;
            font-size: 12px;
            line-height: 14px;
            margin-top: 20px;

            span {
              display: inline-block;
              font-weight: 700;
              color: #cacaca;
            }

            .price-icon,
            .price-num {
              color: #d44d44;
            }

            .price-num {
              margin-left: 5px;
              font-size: 14px;
            }

            .item-num {
              margin-left: 10px;
            }
          }

        }

        .cart-cell {
          display: table-cell;
          vertical-align: middle;
        }

        .del {
          display: none;
          overflow: hidden;
          position: absolute;
          right: 20px;
          top: 50%;
          transform: translateY(-50%);
        }
      }

      .nav-cart-total {
        box-sizing: content-box;
        position: relative;
        padding: 20px;
        // height: 40px;
        background: #fafafa;
        border-top: 1px solid #f0f0f0;
        border-radius: 0 0 8px 8px;
        box-shadow: inset 0 -1px 0 hsla(0, 0%, 100%, .5), 0 -3px 8px rgba(0, 0, 0, .04);
        background: -webkit-linear-gradient(#fafafa, #f5f5f5);
        background: linear-gradient(#fafafa, #f5f5f5);

        p {
          margin-bottom: 4px;
          line-height: 16px;
          font-size: 12px;
          color: #c1c1c1;
        }

        h5 {
          line-height: 20px;
          font-size: 14px;
          color: #6f6f6f;

          span {
            font-size: 18px;
            color: #de4037;
            display: inline-block;
            font-weight: 700;
          }

          span:first-child {
            font-size: 12px;
            margin-right: 5px;
          }
        }

        h6 {
          position: absolute;
          right: 20px;
          top: 20px;
          width: 108px;
        }
      }
    }

    // 购物车
    .cart {

      &:hover {
        a:before {
          background: url(/static/images/rbox/cart_fill.png) no-repeat center bottom / 100% auto;
        }

        .nav-user-wrapper.active {
          top: 18px;
          visibility: visible;
          opacity: 1;
          -webkit-transition: opacity .15s ease-out;
          transition: opacity .15s ease-out;
        }

      }

      >a {
        position: relative;
        @include wh(50px, 20px);
        display: block;
        text-indent: -9999px;

        &:before {
          content: " ";
          position: absolute;
          left: 15px;
          top: 0;
          @include wh(20px);
          background: url(/static/images/rbox/cart.png) no-repeat center bottom / 100% auto;
          transition: none;
        }

      }

      li {
        text-align: center;
        position: relative;
        border-top: 1px solid #f5f5f5;
        line-height: 44px;
        height: 44px;
        color: #616161;
        font-size: 12px;

        &:hover {
          background: #fafafa;
        }

        a {
          display: block;
          color: #616161;
        }

      }

      .msg-num {
        position: absolute;
        display: block;
        margin-left: 25px;
        margin-top: -25px;
        min-width: 30px;
        text-indent: 0;
        line-height: 20px;

        >i {
          background: #eb746b;
          background-image: -webkit-linear-gradient(#eb746b, #e25147);
          background-image: linear-gradient(#eb746b, #e25147);
          box-shadow: inset 0 0 1px hsla(0, 0%, 100%, .15), 0 1px 2px hsla(0, 0%, 100%, .15);
          text-align: center;
          font-style: normal;
          display: inline-block;
          @include wh(12px);
          border-radius: 12px;
          color: #fff;
          font-size: 12px;

          &.no {
            background: #969696;
            background-image: -webkit-linear-gradient(#A4A4A4, #909090);
            background-image: linear-gradient(#A4A4A4, #909090);
            box-shadow: inset 0 0 1px #838383, 0 1px 2px #838383;
          }
        }

      }

      .nav-user-wrapper {
        right: 0;
        width: 168px;

        .nav-user-list {
          &:before {
            right: 13px;
          }
        }
      }

      .nav-user-list {
        padding: 0;
        width: 100%;

        .full {
          border-radius: 8px;
          overflow: hidden;
        }

        .nav-msg-items {
          max-height: 363px;
          overflow-x: hidden;
          overflow-y: auto;
        }

        .msg-item {
          height: 44px;
          width: 100%;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;

          &:hover {
            background: #fcfcfc;
          }

          .msg-item-desc {
            color: #616161;
            font-size: 12px;
          }

          .msg-item-num {
            position: absolute;
            right: 10px;
            display: block;
            min-width: 30px;
            text-indent: 0;
            line-height: 20px;

            >i {
              background: #eb746b;
              background-image: -webkit-linear-gradient(#eb746b, #e25147);
              background-image: linear-gradient(#eb746b, #e25147);
              box-shadow: inset 0 0 1px hsla(0, 0%, 100%, .15), 0 1px 2px hsla(0, 0%, 100%, .15);
              text-align: center;
              font-style: normal;
              display: inline-block;
              @include wh(20px);
              border-radius: 20px;
              color: #fff;
              font-size: 12px;

              &.no {
                background: #969696;
                background-image: -webkit-linear-gradient(#A4A4A4, #909090);
                background-image: linear-gradient(#A4A4A4, #909090);
                box-shadow: inset 0 0 1px #838383, 0 1px 2px #838383;
              }
            }

          }


        }

        li:first-child .msg-item:first-child {
          border-top: none;
          border-radius: 8px 8px 0 0;
          overflow: hidden;
        }

      }

      .nav-msg-total {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        height: 44px;
        background: #fafafa;
        border-top: 1px solid #f0f0f0;
        border-radius: 0 0 8px 8px;
        box-shadow: inset 0 -1px 0 hsla(0, 0%, 100%, .5), 0 -3px 8px rgba(0, 0, 0, .04);
        background: -webkit-linear-gradient(#fafafa, #f5f5f5);
        background: linear-gradient(#fafafa, #f5f5f5);

        &:hover {
          background: #fcfcfc;
        }

        a {
          display: block;
          color: #616161;
        }
      }

    }

  }

  @media (max-height: 780px) {
    .nav-msg-items {
      max-height: 423px !important;
    }
  }

  @media (max-height: 900px) {
    .nav-msg-items {
      max-height: 544px !important;
    }
  }

  @media (max-height: 1080px) {
    .nav-msg-items {
      max-height: 620px !important;
    }
  }

  // 用户信息弹出
  .nav-user-wrapper {

    position: absolute;
    z-index: 30;
    padding-top: 18px;
    opacity: 0;
    visibility: hidden;
    top: -3000px;

    .nav-user-list {
      position: relative;
      padding-top: 20px;
      background: #fff;
      border: 1px solid #d6d6d6;
      border-color: rgba(0, 0, 0, .08);
      border-radius: 8px;
      box-shadow: 0 20px 40px rgba(0, 0, 0, .15);
      z-index: 10;

      &:before {
        position: absolute;
        content: " ";
        background: url(/static/images/account-icon@2x.32d87deb02b3d1c3cc5bcff0c26314ac.png) no-repeat -49px -43px;
        background-size: 240px 107px;
        @include wh(20px, 8px);
        top: -8px;
        margin-left: -10px;
      }
    }
  }

  .nav-sub {
    position: relative;
    z-index: 20;
    height: 45px;
    // background: #f7f7f7;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .04);

    &.fixed {
      position: fixed;
      z-index: 21;
      height: 45px;
      top: 0;
      left: 0;
      right: 0;
      border-bottom: 1px solid #dadada;
      background-image: -webkit-linear-gradient(#fff, #f1f1f1);
      background-image: linear-gradient(#fff, #f1f1f1);
    }

    .nav-sub-wrapper {
      height: 45px;
      position: relative;
      display: flex;
      align-items: center;

      &.fixed {
        padding: 0;
        height: 100%;
      }

    }

    .w {
      display: flex;
      justify-content: space-between;
    }

    .nav-sub-list {
      height: 28px;
      line-height: 28px;
      display: flex;
      align-items: center;
      height: 100%;

      li:first-child {
        padding-left: 0;

        a {
          padding-left: 0px;
        }
      }

      li {
        position: relative;
        float: left;
        padding-left: 2px;
        margin-right: 10px;

        a {
          display: block;
          padding: 0 10px;
          color: #666;

          &.active {
            // font-weight: bold;
            color: #00a5d5;
          }
        }

        a:hover {
          color: #00a5d5;
        }
      }

    }
  }

  @media (min-width: 1px) {
    .nav-sub .nav-sub-wrapper:after {
      display: block;
    }
  }

  .cart-con {
    /*display: flex;*/
    text-align: center;
    position: relative;

    p {
      padding-top: 185px;
      color: #333333;
      font-size: 16px;
    }
  }

  .cart-con:before {
    position: absolute;
    content: ' ';
    left: 50%;
    transform: translate(-50%, -70%);
    top: 50%;
    width: 76px;
    height: 62px;
    background: url("/static/images/cart-empty-new.png") no-repeat;
    background-size: cover;
  }
  .bot-hr,.bot-login{
    height: 5px;
    background-color: #0A5FE1;
    box-shadow:0px 5px 5px -2px black;/* #878787 */
    margin-top: -24px;
  }
  .bot-hr{
    width: 75.8%;
    margin-left: 12.7%;
  }
  .bot-login{
    width: 100%;
    margin-top: -9px;
  }
  .display{
    display: none;
  }
  .header-title {
    position: absolute;
    left: 0px;
    right: 0px;
    top: 0px;
    background-color: #0ca9d2;
    color: #fff;
    font-size: 22px;
    font-weight: 600;
  }
  .item .p {
    background: #f56521;
    padding: 12px;
    text-align: center;
    border-radius: 10px;
    color: #fff;
  }


</style>



// WEBPACK FOOTER //
// MHeader.vue?227d5c34